type Interval = { start_ms: number; end_ms: number };
type TimelineInput = {
  speech_regions: (Interval & { kind: string; over_music: number })[];
  music_regions: (Interval & { kind?: string })[];
};
export function mergeIntervals(
  regions: Interval[],
  duration: number,
): Interval[] {
  const sorted = regions
    .map((r) => ({
      start_ms: Math.max(0, r.start_ms),
      end_ms: Math.min(duration, r.end_ms),
    }))
    .filter(
      (r) =>
        Number.isFinite(r.start_ms) &&
        Number.isFinite(r.end_ms) &&
        r.end_ms > r.start_ms,
    )
    .sort((a, b) => a.start_ms - b.start_ms);
  const result: Interval[] = [];
  for (const r of sorted) {
    const last = result[result.length - 1];
    if (last && r.start_ms <= last.end_ms)
      last.end_ms = Math.max(last.end_ms, r.end_ms);
    else result.push({ ...r });
  }
  return result;
}
export function audioMap(data: TimelineInput | null, duration: number) {
  const speech = mergeIntervals(
    data?.speech_regions.filter((r) => r.kind === "speech") || [],
    duration,
  );
  const music = mergeIntervals(
    [
      ...(data?.music_regions.filter((r) => r.kind === "music") || []),
      ...(data?.speech_regions.filter(
        (r) => r.kind === "music_only" || r.over_music === 1,
      ) || []),
    ],
    duration,
  );
  const boundaries = [
    ...new Set([
      0,
      duration,
      ...speech.flatMap((r) => [r.start_ms, r.end_ms]),
      ...music.flatMap((r) => [r.start_ms, r.end_ms]),
    ]),
  ].sort((a, b) => a - b);
  return { speech, music, boundaries };
}
